/*
  Diamond Search — Vue 2 storefront app for browsing loose diamonds.

  Markup: templates/page.dd.liquid  |  Styles: assets/diamondsearch.css
  Developer guide: docs/diamond-search.md

  Flow: parse /apps/diamondsearch URL → optional single-stone load → noUiSlider
  filters → GraphQL diamondInventorySearch on window.apiBaseUrl.

  Vue delimiters are [[ ]] so they do not clash with Liquid.

  TODO:
	[ ] Check if is provenance deprecated.
*/

window.__evosem_ssurl = "https://shopify.evosem.com";
window.flowURL = Shopify.shop.includes("thai") ? `https://rockher-thai-flow.evosem.com` : `https://rockher-flow.evosem.com`; //This is the URL of the flow server.
window.currentCurrencySymbol = Shopify.currencySymbol(Shopify.currency.active, Shopify.locale);
window.__price = { min: 391, max: 5359080 };
window.__carat = { min: 0.4, max: 22 };
window.__depth = { min: 0, max: 100 };
window.__table = { min: 0, max: 100 };
window.__ratio = { min: 0, max: 100 };
window.diamondsFancyColours = [
	{
		label: "Yellow",
		value: "Yellow",
		shortcode: "yellow",
		colour_code: "yellow", //Hex colour code here please.
	},
	{
		label: "Pink",
		value: "Pink",
		shortcode: "pink",
	},
	{
		label: "Purple",
		value: "Purple",
		shortcode: "purple",
		colour_code: "purple", //Hex colour code here please.
	},
	{
		label: "Blue",
		value: "Blue",
		shortcode: "blue",
		colour_code: "blue", //Hex colour code here please.
	},
	{
		label: "Grey",
		value: "Grey",
		shortcode: "grey",
		colour_code: "grey", //Hex colour code here please.
	},
	{
		label: "Green",
		value: "Green",
		shortcode: "green",
		colour_code: "green", //Hex colour code here please.
	},
];
window.diamondsColours = [
	{
		label: "K",
		value: "K",
		shortcode: "K",
	},
	{
		label: "J",
		value: "J",
		shortcode: "J",
	},
	{
		label: "I",
		value: "I",
		shortcode: "I",
	},
	{
		label: "H",
		value: "H",
		shortcode: "H",
	},
	{
		label: "G",
		value: "G",
		shortcode: "G",
	},
	{
		label: "F",
		value: "F",
		shortcode: "F",
	},
	{
		label: "E",
		value: "E",
		shortcode: "E",
	},
	{
		label: "D",
		value: "D",
		shortcode: "D",
	},
];
window.diamondsClarity = [
	{
		label: "SI2",
		value: "SI2",
		shortcode: "SI2",
	},
	{
		label: "SI1",
		value: "SI1",
		shortcode: "SI1",
	},
	{
		label: "VS2",
		value: "VS2",
		shortcode: "VS2",
	},
	{
		label: "VS1",
		value: "VS1",
		shortcode: "VS1",
	},
	{
		label: "VVS2",
		value: "VVS2",
		shortcode: "VVS2",
	},
	{
		label: "VVS1",
		value: "VVS1",
		shortcode: "VVS1",
	},
	{
		label: "IF",
		value: "IF",
		shortcode: "IF",
	},
	{
		label: "FL",
		value: "FL",
		shortcode: "FL",
	},
];
window.diamondsCut = [
	{
		label: "fair",
		value: "FAIR",
		shortcode: "F",
	},
	{
		label: "good",
		value: "GOOD",
		shortcode: "G",
	},
	{
		label: "very good",
		value: "VERY GOOD",
		shortcode: "VG",
	},
	{
		label: "excellent",
		value: "EXCELLENT",
		shortcode: "EX",
	},
	{
		label: "ideal",
		value: "IDEAL",
		shortcode: "ID",
	},
];
window.diamondsFluorescences = [
	{
		label: "Very Strong",
		value: "VERY STRONG",
		shortcode: "VS",
	},
	{
		label: "Strong",
		value: "STRONG",
		shortcode: "S",
	},
	{
		label: "Medium",
		value: "MEDIUM",
		shortcode: "M",
	},
	{
		label: "Faint",
		value: "FAINT",
		shortcode: "F",
	},
	{
		label: "None",
		value: "NONE",
		shortcode: "N",
	},
];
window.diamondsIntensity = [
	{
		label: "Deep",
		value: "DEEP",
		shortcode: "D",
	},
	{
		label: "Vivid",
		value: "VIVID",
		shortcode: "V",
	},
	{
		label: "Intense",
		value: "INTENSE",
		shortcode: "I",
	},
	{
		label: "Fancy",
		value: "FANCY",
		shortcode: "F",
	},
	{
		label: "Fancy Light",
		value: "FANCY LIGHT",
		shortcode: "FL",
	},
	{
		label: "Light",
		value: "LIGHT",
		shortcode: "L",
	},
];
window.diamondsSymmetry = [
	{
		label: "fair",
		value: "FAIR",
		shortcode: "F",
	},
	{
		label: "good",
		value: "GOOD",
		shortcode: "G",
	},
	{
		label: "very good",
		value: "VERY GOOD",
		shortcode: "VG",
	},
	{
		label: "excellent",
		value: "EXCELLENT",
		shortcode: "EX",
	},
];
window.diamondsPolish = [
	{
		label: "fair",
		value: "FAIR",
		shortcode: "F",
	},
	{
		label: "good",
		value: "GOOD",
		shortcode: "G",
	},
	{
		label: "very good",
		value: "VERY GOOD",
		shortcode: "VG",
	},
	{
		label: "excellent",
		value: "EXCELLENT",
		shortcode: "EX",
	},
	{
		label: "ideal",
		value: "IDEAL",
		shortcode: "ID",
	},
];
window.diamondsShapes = [
	{
		label: "round",
		value: "Round",
		icon: "round",
	},
	{
		label: "oval",
		value: "Oval",
		icon: "oval",
	},
	{
		label: "cushion",
		value: "Cushion",
		icon: "cushion",
	},
	{
		label: "princess",
		value: "Princess",
		icon: "princess",
	},
	{
		label: "pear",
		value: "Pear",
		icon: "pear",
	},
	{
		label: "emerald",
		value: "Emerald",
		icon: "emerald",
	},
	{
		label: "marquise",
		value: "Marquise",
		icon: "marquise",
	},
	{
		label: "asscher",
		value: "Asscher",
		icon: "asscher",
	},
	{
		label: "radiant",
		value: "Radiant",
		icon: "radiant",
	},
	{
		label: "heart",
		value: "Heart",
		icon: "heart",
	},
	{
		label: "Shield",
		value: "Shield",
		icon: "Shield",
	},
	{
		label: "Rose",
		value: "Rose",
		icon: "Rose",
	},
	{
		label: "Triangular",
		value: "Triangular",
		icon: "Triangular",
	},
	{
		label: "Hexagonal",
		value: "Hexagonal",
		icon: "Hexagonal",
	},
	{
		label: "Kite",
		value: "Kite",
		icon: "Kite",
	},
	{
		label: "Tapered Baguette",
		value: "Tapered Baguette",
		icon: "TaperedBaguette",
	},
	{
		label: "Square Emerald",
		value: "Square Emerald",
		icon: "SquareEmerald",
	},
	{
		label: "Briolette",
		value: "Briolette",
		icon: "Briolette",
	},
	{
		label: "Half Moon",
		value: "Half Moon",
		icon: "HalfMoon",
	},
	{
		label: "European Cut",
		value: "European Cut",
		icon: "EuropeanCut",
	},
];
window.diamondQueryTemplate = `
	query (
		$filter: DiamondFilterInput
		$sort: DiamondSortInput
		$pageSize: Int
		$currentPage: Int
	) {
		diamondInventorySearch(
			filter: $filter
			sort: $sort
			pageSize: $pageSize
			currentPage: $currentPage
		) {
			total_count_all
			total_count
			page_size
			current_page
			items {
				visual_carat
				carat
				clarity
				crown_angle
				culet
				cut
				depth
				diamond_video
				diamond_image
				diamondcolor
				dim_depth
				dim_length
				dim_width
				dimensions
				fancy_intensity
				fancycolor
				fluorescence
				gia_report_num
				girdle
				rosi_score
				hca_score
				image
				is_fancy
				is_idealcut
				is_labgrown
				is_returnable
				is_idealplus:is_superidealcut
				lab
				name
				pavilion_angle
				polish
				price
				price_per_carat
				fprice
				qty
				ratio
				shape
				shipping_days
				sku
				small_image
				status
				symmetry
				tabl
				thumbnail
				url_key
				vendor
				vendor_stock_num
			}
		}
	}
`;

document.addEventListener("DOMContentLoaded", () => {
	window.initialiseSlider = () => {
		//Render steps.
		const stepsRender = (element, labels) => {
			if (element) {
				const labelsList = document.createElement("ul");
				labelsList.classList.add("tw-flex", "tw-gap-2", "tw-items-center", "tw-justify-between", "tw-text-xs", "tw-text-rockher-secondary", "tw-mt-4", "tw-text-center");

				labels.map((label) => {
					const item = document.createElement("li");
					const text = document.createElement("span");
					text.classList.add("separation-text", "tw-relative", "tw-text-center", "tw-capitalize", "tw-block", "tw-h-0");
					text.innerText = label.label;
					item.classList.add("tw-relative");
					item.appendChild(text);
					item.style.width = `${100 / labels.length}%`;
					const separation = document.createElement("span");
					separation.classList.add("separation", "tw-absolute", "tw-top-[-15px]", "tw-right-[-0.5px]", "tw-w-[1px]", "tw-h-[5px]", "tw-bg-white", "tw-z-[2]");
					item.appendChild(separation);
					return labelsList.appendChild(item);
				});

				element.appendChild(labelsList);
			}
		};

		//Initialise Price Slider
		const priceSlider = document.getElementById("price-slider");
		if (priceSlider) {
			noUiSlider.create(priceSlider, {
				range: {
					min: [parseFloat(__price.min)],
					"40%": [10000 * parseFloat(Shopify.currency.rate), 1],
					"70%": [20000 * parseFloat(Shopify.currency.rate), 1],
					"90%": [80000 * parseFloat(Shopify.currency.rate), 1],
					max: [parseFloat(__price.max)],
				},
				start: [parseFloat(__price.min), parseFloat(__price.max)],
				connect: true,
			});

			priceSlider.noUiSlider.on("update", (values) => {
				const formatter = wNumb({
					thousand: ",",
					decimals: 0,
					prefix: currentCurrencySymbol,
				});
				if (document.getElementById("display-price-slide-from")) document.getElementById("display-price-slide-from").value = formatter.to(parseFloat(values[0]));
				if (document.getElementById("display-price-slide-to")) document.getElementById("display-price-slide-to").value = formatter.to(parseFloat(values[1]));
			});
			priceSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.price = {
					min: values[0],
					max: values[1],
				};
			});
		}

		//Initialise carat slider.
		const caratSlider = document.getElementById("carat-slider");
		if (caratSlider) {
			noUiSlider.create(caratSlider, {
				range: {
					min: parseFloat(__carat.min),
					max: parseFloat(__carat.max),
				},
				start: [parseFloat(__carat.min), parseFloat(__carat.max)],
				connect: true,
			});
			caratSlider.noUiSlider.on("update", (values) => {
				const formatter = wNumb({
					thousand: ",",
					decimals: 2,
					suffix: "ct",
				});
				if (document.getElementById("display-carat-slide-from")) document.getElementById("display-carat-slide-from").value = formatter.to(parseFloat(values[0]));
				if (document.getElementById("display-carat-slide-to")) document.getElementById("display-carat-slide-to").value = formatter.to(parseFloat(values[1]));
			});
			caratSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.carat = {
					min: values[0],
					max: values[1],
				};
			});
		}

		//Initialise cut slider.
		const cutSlider = document.getElementById("cut-slider");
		if (cutSlider) {
			noUiSlider.create(cutSlider, {
				range: {
					min: 0,
					max: diamondsCut.length,
				},
				start: [0, diamondsCut.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __cutSlider = cutSlider.noUiSlider.get(true);
			const cutSlideLabels = cutSlider.parentElement.querySelector(".steps-labels");
			stepsRender(cutSlideLabels, diamondsCut);

			cutSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.cut = diamondsCut.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise clarity slider.
		const claritySlider = document.getElementById("clarity-slider");
		if (claritySlider) {
			noUiSlider.create(claritySlider, {
				range: {
					min: 0,
					max: diamondsClarity.length,
				},
				start: [0, diamondsClarity.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __claritySlider = claritySlider.noUiSlider.get(true);
			const claritySlideLabels = claritySlider.parentElement.querySelector(".steps-labels");
			stepsRender(claritySlideLabels, diamondsClarity);

			claritySlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.clarity = diamondsClarity.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise color slider.
		const colorSlider = document.getElementById("color-slider");
		if (colorSlider) {
			noUiSlider.create(colorSlider, {
				range: {
					min: 0,
					max: diamondsColours.length,
				},
				start: [0, diamondsColours.length],
				connect: true,
				step: 1,
			});
			//Initialise the search parameters with the values set.
			const __colorSlider = colorSlider.noUiSlider.get(true);
			const colorSlideLabels = colorSlider.parentElement.querySelector(".steps-labels");
			stepsRender(colorSlideLabels, diamondsColours);

			colorSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.color = diamondsColours.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise depth slider.
		const tableSlider = document.getElementById("table-slider");
		if (tableSlider) {
			noUiSlider.create(tableSlider, {
				range: {
					min: parseFloat(window.__table.min),
					max: parseFloat(window.__table.max),
				},
				start: [parseFloat(0), parseFloat(100)],
				connect: true,
			});
			tableSlider.noUiSlider.on("update", (values) => {
				const formatter = wNumb({
					thousand: ",",
					decimals: 2,
					suffix: "%",
				});
				if (document.getElementById("display-table-slide-from")) document.getElementById("display-table-slide-from").value = formatter.to(parseFloat(values[0]));
				if (document.getElementById("display-table-slide-to")) document.getElementById("display-table-slide-to").value = formatter.to(parseFloat(values[1]));
			});

			tableSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.table = {
					min: values[0],
					max: values[1],
				};
			});
		}

		//Initialise depth slider.
		const depthSlider = document.getElementById("depth-slider");
		if (depthSlider) {
			noUiSlider.create(depthSlider, {
				range: {
					min: parseFloat(window.__depth.min),
					max: parseFloat(window.__depth.max),
				},
				start: [parseFloat(0), parseFloat(100)],
				connect: true,
			});
			depthSlider.noUiSlider.on("update", (values) => {
				const formatter = wNumb({
					thousand: ",",
					decimals: 2,
					suffix: "%",
				});
				if (document.getElementById("display-depth-slide-from")) document.getElementById("display-depth-slide-from").value = formatter.to(parseFloat(values[0]));
				if (document.getElementById("display-depth-slide-to")) document.getElementById("display-depth-slide-to").value = formatter.to(parseFloat(values[1]));
			});

			depthSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.depth = {
					min: values[0],
					max: values[1],
				};
			});
		}

		//Initialise ratio slider.
		const ratioSlider = document.getElementById("ratio-slider");
		if (ratioSlider) {
			noUiSlider.create(ratioSlider, {
				range: {
					min: parseFloat(window.__ratio.min),
					max: parseFloat(window.__ratio.max),
				},
				start: [parseFloat(0), parseFloat(100)],
				connect: true,
			});
			ratioSlider.noUiSlider.on("update", (values) => {
				const formatter = wNumb({
					thousand: ",",
					decimals: 2,
					suffix: "%",
				});
				document.getElementById("display-ratio-slide-from").textContent = formatter.to(parseFloat(values[0]));
				document.getElementById("display-ratio-slide-to").textContent = formatter.to(parseFloat(values[1]));
			});

			ratioSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.ratio = {
					min: values[0],
					max: values[1],
				};
			});
		}

		//Initialise polish slider.
		const polishSlider = document.getElementById("polish-slider");
		if (polishSlider) {
			noUiSlider.create(polishSlider, {
				range: {
					min: 0,
					max: diamondsPolish.length,
				},
				start: [0, diamondsPolish.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __polishSlider = polishSlider.noUiSlider.get(true);
			const polishSlideLabels = polishSlider.parentElement.querySelector(".steps-labels");
			stepsRender(polishSlideLabels, diamondsPolish);

			polishSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.polish = diamondsPolish.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise symmetry slider.
		const symmetrySlider = document.getElementById("symmetry-slider");
		if (symmetrySlider) {
			noUiSlider.create(symmetrySlider, {
				range: {
					min: 0,
					max: diamondsSymmetry.length,
				},
				start: [0, diamondsSymmetry.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __symmetrySlider = symmetrySlider.noUiSlider.get(true);
			const symmetrySlideLabels = symmetrySlider.parentElement.querySelector(".steps-labels");
			stepsRender(symmetrySlideLabels, diamondsSymmetry);

			symmetrySlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.symmetry = diamondsSymmetry.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise fluorescences slider.
		const fluorescencesSlider = document.getElementById("fluorescences-slider");
		if (fluorescencesSlider) {
			noUiSlider.create(fluorescencesSlider, {
				range: {
					min: 0,
					max: diamondsFluorescences.length,
				},
				start: [0, diamondsFluorescences.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __fluorescencesSlider = fluorescencesSlider.noUiSlider.get(true);
			const fluorescencesSlideLabels = fluorescencesSlider.parentElement.querySelector(".steps-labels");
			stepsRender(fluorescencesSlideLabels, diamondsFluorescences);

			fluorescencesSlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.fluorescence = diamondsFluorescences.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		//Initialise intensity slider.
		const intensitySlider = document.getElementById("intensity-slider");
		if (intensitySlider) {
			noUiSlider.create(intensitySlider, {
				range: {
					min: 0,
					max: diamondsFluorescences.length,
				},
				start: [0, diamondsFluorescences.length],
				connect: true,
				step: 1,
			});

			//Initialise the search parameters with the values set.
			const __intensitySlider = intensitySlider.noUiSlider.get(true);
			const intensitySlideLabels = intensitySlider.parentElement.querySelector(".steps-labels");
			stepsRender(intensitySlideLabels, diamondsIntensity);

			intensitySlider.noUiSlider.on("set", (values, handle) => {
				searchView.searchParams.fancyintensity = diamondsIntensity.slice(parseInt(values[0]), parseInt(values[1])).map((i) => i.shortcode);
			});
		}

		window.priceSlider = priceSlider;
		window.caratSlider = caratSlider;
		window.cutSlider = cutSlider;
		window.claritySlider = claritySlider;
		window.colorSlider = colorSlider;
		window.tableSlider = tableSlider;
		window.depthSlider = depthSlider;
		window.ratioSlider = ratioSlider;
		window.polishSlider = polishSlider;
		window.symmetrySlider = symmetrySlider;
		window.fluorescencesSlider = fluorescencesSlider;
		window.intensitySlider = intensitySlider;
	};

	document.getElementById("diamond-search").style.display = "";

	const router = new VueRouter({
		mode: "history", // Optional: cleaner URLs
	});

	const searchView = new Vue({
		name: "SearchView",
		el: "#diamond-search",
		delimiters: ["[[", "]]"],
		router,
		data: {
			compareItems: [],
			pathname: "/apps/diamondsearch",
			isLoading: false,
			isReady: false,
			addtoringloading: false,
			addtobagloading: false,
			viewMode: "grid",
			isFiltersOpen: false,
			showMethodology: false,
			diamondShapes: window.diamondsShapes,
			selectedType: "natural",
			selectedCertifications: ["IGI", "GIA"],
			sortByList: [
				{
					label: "ROSI™ Score",
					value: "rosi_score_desc",
					shortcode: "rosi_score",
					direction: "DESC",
				},
				{
					label: "Price - Low to High",
					value: "price_asc",
					shortcode: "price",
					direction: "ASC",
				},
				{
					label: "Price - High to Low",
					value: "price_desc",
					shortcode: "price",
					direction: "DESC",
				},
				{
					label: "Carat - Low to High",
					value: "carat_asc",
					shortcode: "carat",
					direction: "ASC",
				},
				{
					label: "Carat - High to Low",
					value: "carat_desc",
					shortcode: "carat",
					direction: "DESC",
				},
			],
			selectedSort: "rosi_score_desc",
			isSortDropdownOpen: false,
			showDiamondVideo: false,
			searchParams: {
				shape: window.diamondsShapes[0].value,
				price: window.__price,
				carat: window.__carat,
				cut: window.diamondsCut.map((cut) => cut.shortcode),
				clarity: window.diamondsClarity.map((clarity) => clarity.shortcode),
				color: window.diamondsColours.map((color) => color.shortcode),
				table: window.__table,
				depth: window.__depth,
				ratio: window.__ratio,
				polish: window.diamondsPolish.map((polish) => polish.shortcode),
				symmetry: window.diamondsSymmetry.map((symmetry) => symmetry.shortcode),
				fluorescence: window.diamondsFluorescences.map((fluorescence) => fluorescence.shortcode),
				fancyintensity: window.diamondsIntensity.map((intensity) => intensity.shortcode),
				is_labgrown: false,
				is_fancy: false,
				fancycolor: window.diamondsFancyColours[0].value,
				is_idealcut: false,
				is_idealplus: false,
				orderby: "rosi_score",
				order: "DESC",
				offset: 0,
			},
			queryResult: {
				total_count: 0,
				total_count_all: 0,
				items: [],
			},
			singleDiamond: null,
		},
		mounted: async function () {
			const pathName = window.location.pathname.split("/");
			if (pathName.includes("natural") && !pathName.includes("lab-grown-diamonds")) this.selectedType = "natural";
			if (pathName.includes("labgrown") || pathName.includes("lab-grown-diamonds")) this.selectedType = "lab-grown";
			if (pathName.includes("fancycolor")) this.searchParams.is_fancy = true;
			if (pathName.includes("idealcut")) this.searchParams.is_idealcut = true;
			if (pathName.includes("idealplus")) this.searchParams.is_idealplus = true;
			if (pathName.includes("round-cut")) this.searchParams.shape = "Round";
			if (pathName.includes("oval-cut")) this.searchParams.shape = "Oval";
			if (pathName.includes("cushion-cut")) this.searchParams.shape = "Cushion";
			if (pathName.includes("princess-cut")) this.searchParams.shape = "Princess";
			if (pathName.includes("pear-cut")) this.searchParams.shape = "Pear";
			if (pathName.includes("emerald-cut")) this.searchParams.shape = "Emerald";
			if (pathName.includes("marquise-cut")) this.searchParams.shape = "Marquise";
			if (pathName.includes("asscher-cut")) this.searchParams.shape = "Asscher";
			if (pathName.includes("radiant-cut")) this.searchParams.shape = "Radiant";
			if (pathName.includes("heart-cut")) this.searchParams.shape = "Heart";
			if (pathName.includes("shield-cut")) this.searchParams.shape = "Shield";
			if (pathName.includes("rose-cut")) this.searchParams.shape = "Rose";
			if (pathName.includes("triangular-cut")) this.searchParams.shape = "Triangular";
			if (pathName.includes("hexagonal-cut")) this.searchParams.shape = "Hexagonal";
			if (pathName.includes("kite-cut")) this.searchParams.shape = "Kite";
			if (pathName.includes("tapered-baguette-cut")) this.searchParams.shape = "Tapered Baguette";
			if (pathName.includes("square-emerald-cut")) this.searchParams.shape = "Square Emerald";
			if (pathName.includes("briolette-cut")) this.searchParams.shape = "Briolette";
			if (pathName.includes("half-cut")) this.searchParams.shape = "Half Moon";
			if (pathName.includes("european-cut")) this.searchParams.shape = "European Cut";

			await this.loadSingleDiamond();

			window.initialiseSlider();

			if (Shopify.currency.active === "THB") {
				const usdToThbRate = await queryUsdToThbRate();
				Shopify.currency.rate = usdToThbRate;
			}
			setTimeout(async () => {
				await this.searchRequest(true);
			}, 50);
			this.isReady = true;

			window.addEventListener("popstate", this.handlePopState);
		},
		beforeDestroy() {
			window.removeEventListener("popstate", this.handlePopState);
		},
		methods: {
			skuSearchInput() {
				//If the input is empty, then reset the search.
			},
			resetFilters: function () {
				// this.isFiltersOpen = false;
				// Reset the price range and any related options.
				priceSlider.noUiSlider.set([parseFloat(__price.min), parseFloat(__price.max)]);
				caratSlider.noUiSlider.set([parseFloat(__carat.min), parseFloat(__carat.max)]);
				cutSlider.noUiSlider.set([0, window.diamondsCut.length]);
				claritySlider.noUiSlider.set([0, window.diamondsClarity.length]);
				colorSlider.noUiSlider.set([0, window.diamondsColours.length]);
				tableSlider.noUiSlider.set([parseFloat(window.__table.min), parseFloat(window.__table.max)]);
				depthSlider.noUiSlider.set([parseFloat(window.__depth.min), parseFloat(window.__depth.max)]);
				ratioSlider.noUiSlider.set([parseFloat(window.__ratio.min), parseFloat(window.__ratio.max)]);
				polishSlider.noUiSlider.set([0, window.diamondsPolish.length]);
				symmetrySlider.noUiSlider.set([0, window.diamondsSymmetry.length]);
				fluorescencesSlider.noUiSlider.set([0, window.diamondsFluorescences.length]);
				intensitySlider.noUiSlider.set([0, window.diamondsIntensity.length]);
				this.selectedCertifications = ["IGI", "GIA"];
				this.selectedSort = "rosi_score_desc";
				this.searchParams.offset = 0;
				this.searchParams.is_fancy = false;
				this.searchParams.is_idealcut = false;
				this.searchParams.is_idealplus = false;
				this.searchParams.fancycolor = window.diamondsFancyColours[0].value;
				this.searchParams.skusearch = "";
			},
			showDiamonds: function () {
				this.isFiltersOpen = false;
				this.updateSearch(true);
			},
			updateSearch: _.debounce(function (resetList = false) {
				this.searchRequest(resetList);
			}, 300),
			resetOffset() {
				this.searchParams.offset = 0;
			},
			searchRequest: async function (resetList = false) {
				if (resetList) {
					this.queryResult.items = [];
					this.resetOffset();
				}

				this.isLoading = true;

				const query = window.diamondQueryTemplate;
				const variables = {
					pageSize: 52,
					currentPage: this.searchParams.offset / 52 + 1,
					filter: {
						shape: this.searchParams.shape,
						diamondcolor: this.searchParams.color,
						price_to: parseFloat(this.searchParams.price.max) / parseFloat(Shopify.currency.rate), //Convert it back to USD before submitting.
						price_from: parseFloat(this.searchParams.price.min) / parseFloat(Shopify.currency.rate), //Convert it back to USD before submitting.
						carat_to: this.searchParams.carat.max,
						carat_from: this.searchParams.carat.min,
						ratio_to: parseFloat(this.searchParams.ratio.max),
						ratio_from: parseFloat(this.searchParams.ratio.min),
						tabl_to: parseInt(this.searchParams.table.max),
						tabl_from: parseInt(this.searchParams.table.min),
						depth_to: parseInt(this.searchParams.depth.max),
						depth_from: parseInt(this.searchParams.depth.min),
						cut: this.searchParams.cut,
						clarity: this.searchParams.clarity,
						polish: this.searchParams.polish,
						symmetry: this.searchParams.symmetry,
						is_labgrown: Number(this.searchParams.is_labgrown),
						is_fancy: Number(this.searchParams.is_fancy),
					},
				};

				//If the selected shape is other than round, then we need to remove the cuts from the query.
				if (this.searchParams.shape !== "Round") variables.filter.cut = [];

				if (this.searchParams.orderby && this.searchParams.order) {
					variables.sort = {
						[this.searchParams.orderby]: String(this.searchParams.order).toUpperCase(),
					};
				} else {
					variables.sort = {
						price: "ASC",
					};
				}

				//If rosi_score is the sorting method and the price range is the default price range then we need to remove the price filter from the query to insure appropriate results are returned.
				if (this.searchParams.orderby === "rosi_score" && parseFloat(this.searchParams.price.min) === parseFloat(window.__price.min) && parseFloat(this.searchParams.price.max) === parseFloat(window.__price.max)) {
					delete variables.filter.price_from;
					delete variables.filter.price_to;
				}

				if (this.searchParams.is_idealcut) {
					variables.filter.is_idealcut = Number(this.searchParams.is_idealcut);
				}
				if (this.searchParams.is_idealplus) {
					variables.filter.is_superidealcut = Number(this.searchParams.is_idealplus);
				}

				if (this.searchParams.lab) {
					variables.filter.lab = this.searchParams.lab;
				}

				if (this.searchParams.is_fancy) {
					delete variables.filter.diamondcolor;
					variables.filter.fancycolor = this.searchParams.fancycolor;
					variables.filter.fluorescence = this.searchParams.fluorescence;
					variables.filter.fancy_intensity = this.searchParams.fancyintensity;

					// Make sure to remove the sort by rosi if we fetching coloured diamonds.
					delete variables.sort.rosi_score;
					variables.sort.price = "ASC";
					//Also update the selected option from the dropdown.
					this.selectedSort = "price_asc";
				}

				if (!_.isEmpty(this.searchParams.skusearch)) {
					variables.filter = {
						sku: this.searchParams.skusearch,
					};
					variables.pageSize = 1;
					variables.currentPage = 1;
					variables.sort = {
						price: "ASC",
					};
					this.resetOffset();
				}

				const request = await fetch(`${window.apiBaseUrl}/graphql`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: query,
						variables: variables,
					}),
				});

				//Handle the response errors.
				if (!request.ok) {
					throw new Error(`Error fetching diamonds: ${request.statusText}`);
				}

				//Handle the response data.

				const response = await request.json();
				this.queryResult.total_count = response.data.diamondInventorySearch.total_count;
				this.queryResult.total_count_all = response.data.diamondInventorySearch.total_count_all;
				this.queryResult.items = [...this.queryResult.items, ...response.data.diamondInventorySearch.items];

				this.isLoading = false;
				return this.queryResult;
			},
			rateConvertion: function (price) {
				return parseFloat(Shopify.currency.rate) * parseFloat(price);
			},
			getCutName(_value) {
				return window.diamondsCut.filter((i) => i.shortcode === _value)[0]?.label || _value;
			},
			getIntensityName(_value) {
				return window.diamondsIntensity.filter((i) => i.shortcode === _value)[0]?.label || _value;
			},
			getFluorescencesName(_value) {
				return window.diamondsFluorescences.filter((i) => i.shortcode === _value)[0]?.label || _value;
			},
			getPolishName(_value) {
				return window.diamondsPolish.filter((i) => i.shortcode === _value)[0]?.label || _value;
			},
			getSymmetryName(_value) {
				return window.diamondsSymmetry.filter((i) => i.shortcode === _value)[0]?.label || _value;
			},
			formatNumber(number) {
				if (!_.isNumber(number)) return number;
				return wNumb({ thousand: ",", mark: ".", decimals: 0 }).to(number);
			},
			onImageError(event, item) {
				event.target.src = `https://hermanos.rockher.com/static/frontend/Rockher/Winter/en_US/Rockher_Diamondsearch/images/diamondsearch/shapes/${item.shape.toLowerCase().replace(" ", "-")}.jpg`;
			},
			openSingleDiamond(item) {
				this.singleDiamond = item;
				this.loadRecommendations();
				const match = this.singleDiamond.diamond_video?.match(/^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/);
				if (match[0]) this.singleDiamond.diamond_video = match[0];

				//Scroll to the top of the page.
				window.scrollTo(0, 0);

				const customUrl = `${this.singleDiamond.carat}-carat-${this.singleDiamond.shape}-diamond-${this.singleDiamond.sku}`.toLocaleLowerCase().replaceAll(".", "-");
				this.$router.push(`${this.pathname}/${customUrl}`);

				const diamondName = `${parseFloat(this.singleDiamond.carat).toFixed(2)} Carat ${this.singleDiamond.shape} ${this.singleDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`;
				document.title = diamondName;
				if (document.querySelector('meta[name="og:title"]')) document.querySelector('meta[name="og:title"]').setAttribute("content", diamondName);
				if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').setAttribute("content", diamondName);
				if (document.querySelector('meta[property="og:url"]')) document.querySelector('meta[property="og:url"]').setAttribute("content", `${this.pathname}/${customUrl}`);

				if (_learnq) {
					//Event tracker
					const k_item = {
						Name: diamondName,
						ProductID: this.singleDiamond.sku,
						Categories: [`${this.singleDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`],
						ImageURL: this.singleDiamond.diamond_image,
						URL: `https://${Shopify.shop}/apps/diamondsearch/` + `${this.singleDiamond.carat}-carat-${this.singleDiamond.shape}-diamond-${this.singleDiamond.sku}`.toLocaleLowerCase().replaceAll(".", "-"),
						Brand: "Rockher",
						Price: Shopify.formatMoney(this.rateConvertion(this.singleDiamond.price)),
					};

					_learnq.push(["track", "Viewed Product", k_item]);
					_learnq.push([
						"trackViewedItem",
						{
							Title: k_item.Name,
							ItemId: k_item.ProductID,
							Categories: k_item.Categories,
							ImageUrl: k_item.ImageURL,
							Url: k_item.URL,
							Metadata: {
								Brand: k_item.Brand,
								Price: k_item.Price,
							},
						},
					]);
				}
			},
			isDiamondDetailPath(path = window.location.pathname) {
				const subPathNameIndex = _.findIndex(path.split("-"), (i) => i === "diamond");
				return subPathNameIndex !== -1;
			},
			closeSingleDiamondView() {
				this.singleDiamond = null;
				this.showDiamondVideo = false;
				document.title = "Diamond Search";
				if (document.querySelector('meta[name="og:title"]')) document.querySelector('meta[name="og:title"]').setAttribute("content", "Diamond Search");
				if (document.querySelector('meta[property="og:title"]')) document.querySelector('meta[property="og:title"]').setAttribute("content", "Diamond Search");
				if (document.querySelector('meta[property="og:url"]')) document.querySelector('meta[property="og:url"]').setAttribute("content", `${this.pathname}`);
			},
			handlePopState() {
				if (!this.isDiamondDetailPath()) {
					if (this.singleDiamond) this.closeSingleDiamondView();
					return;
				}

				const skuFromUrl = this.getSkuFromPath();
				const normalizeSku = (sku) => `${sku || ""}`.toLocaleLowerCase().replaceAll(".", "-");
				if (normalizeSku(this.singleDiamond?.sku) === normalizeSku(skuFromUrl)) return;

				this.loadSingleDiamond();
			},
			goBackToSearch() {
				this.closeSingleDiamondView();
				this.$router.replace(this.pathname);
			},
			getSkuFromPath(path = window.location.pathname) {
				const subPathName = path.split("-");
				const subPathNameIndex = _.findIndex(subPathName, (i) => i === "diamond");
				if (subPathNameIndex === -1) return null;
				return subPathName.slice(subPathNameIndex + 1).join("-");
			},
			loadSingleDiamond: async function () {
				const stockNumber = this.getSkuFromPath();
				if (!stockNumber) return;

				this.isLoading = true;

				const query = window.diamondQueryTemplate;
				const variables = {
					filter: {
						sku: stockNumber,
					},
				};

				let singleDiamond = await fetch(`${window.apiBaseUrl}/graphql`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: query,
						variables: variables,
					}),
				}).then((response) => response.json());

				singleDiamond = singleDiamond?.data?.diamondInventorySearch?.items[0];

				if (!singleDiamond) {
					//Ignore everything if the diamond is not found.
					return (this.isLoading = false);
				}

				singleDiamond.diamond_video = singleDiamond.diamond_video?.match(/^(https:\/\/loupe360\.com\/diamond\/[^/]+\/video\/)/)?.[0];

				this.singleDiamond = singleDiamond;
				this.showDiamondVideo = false;
				this.loadRecommendations();
				window.scrollTo(0, 0);

				const diamondName = `${parseFloat(this.singleDiamond.carat).toFixed(2)} Carat ${this.singleDiamond.shape} ${this.singleDiamond.is_labgrown ? "Lab Grown" : "Natural"} Diamond`;
				document.title = diamondName;

				this.isLoading = false;
			},
			loadRecommendations: async function () {
				const query = window.diamondQueryTemplate;
				let variables = {
					pageSize: 4,
					currentPage: 1,
					sort: {
						price: "ASC",
					},
					filter: {
						shape: this.singleDiamond.shape,
						price_to: (this.singleDiamond.price + this.singleDiamond.price * 0.15) / 100,
						price_from: (this.singleDiamond.price - this.singleDiamond.price * 0.15) / 100,
						is_labgrown: this.singleDiamond.is_labgrown,
						is_fancy: Number(this.singleDiamond.is_fancy),
					},
				};
				const recommendationsRequest = await fetch(`${window.apiBaseUrl}/graphql`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: query,
						variables,
					}),
				}).then((response) => response.json());

				const items = recommendationsRequest?.data?.diamondInventorySearch?.items;
				if (items) {
					this.$set(this.singleDiamond, "recommendations", items);
				}

				return recommendationsRequest;
			},
			addToRing: async function () {
				if (this.addtobagloading || this.addtoringloading) return;
				let diamond = this.singleDiamond;
				if (!diamond.sku || diamond.price <= 0) return;

				const query = window.diamondQueryTemplate;
				const variables = {
					filter: {
						sku: diamond.sku,
					},
				};

				this.addtoringloading = true;

				const diamondData = await fetch(`${window.apiBaseUrl}/graphql`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: query,
						variables: variables,
					}),
				}).then((response) => response.json());

				if (!diamondData) {
					window.alert("Unable to find the requested diamond please try a different one.");
					return (this.addtoringloading = false); // Skip function.
				}

				let shop_ring_settings = localStorage.getItem(MainRingBuilderStorageKey);

				const diamondRequested = diamond;
				const { shape, carat, sku } = diamondRequested;
				const customUrl = `${carat}-carat-${shape}-diamond-${sku}`.toLocaleLowerCase().replaceAll(".", "-");
				diamondRequested.customUrl = customUrl;
				diamondRequested.priceNumber = diamondRequested.price;

				shop_ring_settings = !_.isEmpty(shop_ring_settings) ? JSON.parse(shop_ring_settings) : {};
				shop_ring_settings.diamond = diamondRequested;

				//Save to localstorage
				const setItemObjection = localStorage.setItem;
				localStorage.setItem = function (key, value) {
					const event = new Event("ringbuilderstoragechange");
					event.value = value; // Optional..
					event.key = key; // Optional..
					document.dispatchEvent(event);
					setItemObjection.apply(this, arguments);
				};

				localStorage.setItem(MainRingBuilderStorageKey, JSON.stringify(shop_ring_settings));
				document.dispatchEvent(
					new CustomEvent("ringbuilderstoragechange", {
						bubbles: true,
						cancelable: true,
					}),
				);

				this.addtoringloading = false;
				if (_.isEmpty(shop_ring_settings.ring)) return (window.location = `/collections/build-an-engagement-ring/?filter.p.m.global.center_shape=${_.head(shapesTypes.filter((s) => s.label === shape)).shortcode}`);
				return (window.location = "/pages/ringbuilder/");
			},
			addToBag: async function () {
				if (this.addtobagloading || this.addtoringloading) return;
				this.addtobagloading = true;

				const diamond = this.singleDiamond;

				//Check if the diamond already exist in the bag.
				const cardItems = await fetch(`/cart.js`, { method: "GET" }).then((response) => response.json());
				if (!_.isEmpty(cardItems.items.filter((item) => item?.properties?.SKU === diamond.sku))) {
					this.addtobagloading = false;
					return window.alert("This diamond is already in your cart.");
				}

				const createDiamond = await fetch(`${window.flowURL}/shopify/setup/creation`, {
					method: "POST",
					mode: "cors",
					cache: "no-cache",
					credentials: "same-origin",
					headers: {
						"x-requested-with": "XMLHttpRequest",
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						stock_number: diamond.sku,
					}),
				}).then((res) => res.json());

				try {
					if (createDiamond.status) {
						const variantId = createDiamond?.shopifyCreate?.data?.productSet?.product?.variants?.edges[0].node?.legacyResourceId;

						const addToCart = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify({
								items: [
									{
										id: variantId,
										quantity: 1,
										properties: {
											SKU: diamond.sku ? diamond.sku : "N/A",
											Cut: diamond.cut ? diamond.cut : this.getSymmetryName(diamond.symmetry),
											Color: diamond.diamondcolor ? diamond.diamondcolor : "N/A",
											Clarity: diamond.clarity ? diamond.clarity : "N/A",
											Lab: diamond.lab ? diamond.lab : "N/A",
											Certificate: diamond.gia_report_num ? diamond.gia_report_num : "N/A",
										},
									},
								],
							}),
						}).then((res) => res.json());

						window.location = `/cart`;
						const k_item = {
							Name: `${parseFloat(diamond.carat).toFixed(2)} Carat ${diamond.shape} ${diamond.is_labgrown ? "Lab-Grown" : "Natural"} Diamond`,
							ProductID: diamond.sku,
							Categories: [`${diamond.is_labgrown ? "Lab-Grown" : "Natural"} Diamond`],
							ImageURL: diamond.diamond_image,
							URL: `https://${Shopify.shop}/apps/diamondsearch/` + `${diamond.carat}-carat-${diamond.shape}-diamond-${diamond.sku}`.toLocaleLowerCase().replaceAll(".", "-"),
							Brand: "Rockher",
							Price: Shopify.formatMoney(this.rateConvertion(diamond.price)),
							$use_ip: true,
							$is_session_activity: true,
						};
						_learnq.push(["track", "Added to Cart", k_item]);

						this.addtobagloading = false;
					} else {
						this.addtobagloading = false;
						return window.alert("An error occurred while adding the diamond to the bag.");
					}
				} catch (error) {
					this.addtobagloading = false;
					return window.alert("An error occurred while adding the diamond to the bag.");
				}
			},
			maxPriceChange: function ($event) {
				try {
					const maxPrice = Number($event.target.value.replaceAll("$", "").replaceAll(",", ""));
					if (this.searchParams.price.max === maxPrice) return;
					priceSlider.noUiSlider.set([parseFloat(this.searchParams.price.min), parseFloat(maxPrice)]);
					this.searchParams.price.max = parseFloat(maxPrice);
				} catch (error) {
					console.log(error);
				}
			},
			minPriceChange: function ($event) {
				try {
					const minPrice = Number($event.target.value.replaceAll("$", "").replaceAll(",", ""));
					if (this.searchParams.price.min === minPrice) return;
					priceSlider.noUiSlider.set([parseFloat(minPrice), parseFloat(this.searchParams.price.max)]);
					this.searchParams.price.min = parseFloat(minPrice);
				} catch (error) {
					console.log(error);
				}
			},
			maxCaratChange: function ($event) {
				try {
					const maxCarat = Number($event.target.value.replaceAll("ct", "").replaceAll(",", ""));
					if (this.searchParams.carat.max === maxCarat) return;
					caratSlider.noUiSlider.set([parseFloat(this.searchParams.carat.min), parseFloat(maxCarat)]);
					this.searchParams.carat.max = parseFloat(maxCarat);
				} catch (error) {
					console.log(error);
				}
			},
			minCaratChange: function ($event) {
				try {
					const minCarat = Number($event.target.value.replaceAll("ct", "").replaceAll(",", ""));
					if (this.searchParams.carat.min === minCarat) return;
					caratSlider.noUiSlider.set([parseFloat(minCarat), parseFloat(this.searchParams.carat.max)]);
					this.searchParams.carat.min = parseFloat(minCarat);
				} catch (error) {
					console.log(error);
				}
			},
			maxTableChange: function ($event) {
				try {
					const maxTable = Number($event.target.value.replaceAll("%", "").replaceAll(",", ""));
					if (this.searchParams.table.max === maxTable) return;
					tableSlider.noUiSlider.set([parseFloat(this.searchParams.table.min), parseFloat(maxTable)]);
					tableSliderMobile.noUiSlider.set([parseFloat(this.searchParams.table.min), parseFloat(maxTable)]);
					this.searchParams.table.max = parseFloat(maxTable);
				} catch (error) {
					console.log(error);
				}
			},
			minTableChange: function ($event) {
				try {
					const minTable = Number($event.target.value.replaceAll("%", "").replaceAll(",", ""));
					if (this.searchParams.table.min === minTable) return;
					tableSlider.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
					tableSliderMobile.noUiSlider.set([parseFloat(minTable), parseFloat(this.searchParams.table.max)]);
					this.searchParams.table.min = parseFloat(minTable);
				} catch (error) {
					console.log(error);
				}
			},
			maxDepthChange: function ($event) {
				try {
					const maxDepth = Number($event.target.value.replaceAll("%", "").replaceAll(",", ""));
					if (this.searchParams.depth.max === maxDepth) return;
					depthSlider.noUiSlider.set([parseFloat(this.searchParams.depth.min), parseFloat(maxDepth)]);
					depthSliderMobile.noUiSlider.set([parseFloat(this.searchParams.depth.min), parseFloat(maxDepth)]);
					this.searchParams.depth.max = parseFloat(maxDepth);
				} catch (error) {
					console.log(error);
				}
			},
			minDepthChange: function ($event) {
				try {
					const minDepth = Number($event.target.value.replaceAll("%", "").replaceAll(",", ""));
					if (this.searchParams.depth.min === minDepth) return;
					depthSlider.noUiSlider.set([parseFloat(minDepth), parseFloat(this.searchParams.depth.max)]);
					depthSliderMobile.noUiSlider.set([parseFloat(minDepth), parseFloat(this.searchParams.depth.max)]);
					this.searchParams.depth.min = parseFloat(minDepth);
				} catch (error) {
					console.log(error);
				}
			},
			generateCompareUrl: function () {
				const items = this.compareItems.map((item) => ({ report_number: item.gia_report_num, lab: item.lab, price: item.price }));
				const path = [];
				for (let i = 0; i < items.length; i++) {
					const item = items[i];
					path.push(`c${i + 1}=${item.report_number}&l${i + 1}=${item.lab}&p${i + 1}=${item.price}`);
				}
				window.location.href = `/pages/rosi-score-report?tab=compare&${path.join("&")}`;
			},
		},
		watch: {
			selectedCertifications(newValue) {
				// If both GIA and IGI are selected, remove the lab from search params only one of them must be passed.
				if (newValue.includes("GIA") && newValue.includes("IGI")) {
					delete this.searchParams.lab;
				} else {
					this.searchParams.lab = newValue.join(",");
				}
			},
			selectedType(newValue) {
				this.searchParams.is_labgrown = newValue === "lab-grown";
				this.searchParams.offset = 0;
				this.searchRequest(true);
			},
			selectedSort(newValue) {
				this.isSortDropdownOpen = false;
				const sort = this.sortByList.find((sort) => sort.value === newValue);
				this.searchParams.orderby = sort.shortcode;
				this.searchParams.order = sort.direction;
				this.searchParams.offset = 0;
				this.searchRequest(true);
			},
			"searchParams.is_fancy"(newValue) {
				if (newValue) this.searchParams.is_idealcut = false;
				if (newValue) this.searchParams.is_idealplus = false;
			},
			"searchParams.is_idealcut"(newValue) {
				if (newValue) this.searchParams.is_idealplus = false;
			},
			"searchParams.is_idealplus"(newValue) {
				if (newValue) this.searchParams.is_idealcut = false;
			},
			"searchParams.shape"(newValue) {
				this.searchParams.offset = 0;
				this.searchRequest(true);
			},
		},
	});
});
